import { useState } from "react";
import { images } from "../constants/images";
import { Link } from "react-router-dom";
import { postNewsletterSubscription } from "../api/utils";

export default function Footer() {
  // const [email, setEmail] = useState("");

  // const handleNewsletterSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!email || !email.includes("@")) {
  //     alert("Please enter a valid email address.");
  //     return;
  //   }

  //   try {
  //     const response = await postNewsletterSubscription({
  //       email: email,
  //       website_url: window.location.origin,
  //     });

  //     if (response.success === "ok" || response.success === true) {
  //       alert(response.message || "You are now part of our community!");
  //     } else {
  //       alert(response.message || "Something went wrong.");
  //     }

  //     // ✅ clear email after any response
  //     setEmail("");

  //   } catch (err) {
  //     console.error(err);
  //     alert("Failed to subscribe. Please try again.");

  //     // ✅ also clear on error
  //     setEmail("");
  //   }
  // };

  const [email, setEmail] = useState("");

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();

    if (!email || !email.includes("@")) {
      alert("Please enter a valid email address.");
      return;
    }

    // Determine purpose based on current page
    let purpose = "Custom Software Development";
    if (window.location.pathname === "/lm/software-audit") {
      purpose = "Software Audit";
    }

    try {
      const response = await postNewsletterSubscription({
        email: email,
        website_url: window.location.origin,
        purpose: purpose, // send dynamic purpose
      });

      if (response.status === "ok" || response.success === true) {
        alert(response.message || "You are now part of our community!");
      } else {
        alert(response.message || "Something went wrong.");
      }

      setEmail(""); // clear email after response
    } catch (err) {
      console.error(err);
      alert("Failed to subscribe. Please try again.");
      setEmail("");
    }
  };

  return (
    <footer>
      <div className="bg-r-img">
        <img src={images?.footerBg} alt="" />
      </div>
      <div className="container">
        <hr className="my-5" />
        <div className="main-footer">
          <div className="row">
            <div className="col-lg-7 col-md-6 foo-list-1">
              <h5 className="tc-primary fs-17 pb-3">
                <strong>ABOUT US</strong>
              </h5>
              <h5 className="tc-primary fs-17" style={{ textAlign: "justify" }}>
                We build reliable solutions on the basis of Customers business
                needs and objectives. Our customers are always happy!
              </h5>
              <h5 className="tc-primary fs-17" style={{ textAlign: "justify" }}>
                Plural Code Technologies is a dynamic software development firm{" "}
                {/* <span className="fs-14">
                  (part of <b>Sarentu IT Solutions Pvt. Ltd.</b>)
                </span> */}
                , based in New Delhi and serving clients worldwide. Founded in
                December 2015, our mission is to simplify web and mobile
                development. Backed by extensive expertise in both web and
                mobile application engineering, Plural Code Technologies
                delivers unparalleled professionalism and streamlined business
                processes. Our portfolio boasts projects of diverse scales,
                showcasing our adaptability and proficiency in the field.
              </h5>
              <br />
              <h5 className="tc-primary fs-17 pb-3">
                <strong>Subscribe to our newsletter</strong>
                <form className="mt-2" onSubmit={handleNewsletterSubmit}>
                  <div className="footer-subscribe-form">
                    <input
                      type="email"
                      placeholder="Enter Your Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    <button type="submit">Send</button>
                  </div>
                </form>
              </h5>
            </div>

            <div className="col-lg-5 col-md-6 foo-list-2">
              <div className="row mt-3 mt-md-0">
                <div className="col-md-5 py-3 py-md-0">
                  <ul>
                    <li className="pb-1">
                      <Link to={"/about"} className="fs-17 tc-primary">
                        About Us
                      </Link>
                    </li>
                    <li className="pb-1">
                      <Link to={"/services"} className="fs-17 tc-primary">
                        Services
                      </Link>
                    </li>
                    <li className="pb-1">
                      <Link
                        to={"/lm/software-audit"}
                        className="fs-17 tc-primary"
                      >
                        Get <b>Free</b> Software Audit
                      </Link>
                    </li>
                    <li className="pb-1">
                      <Link to={"/ourworks"} className="fs-17 tc-primary">
                        Our Works
                      </Link>
                    </li>
                    {/* <li className="pb-1">
                      <Link to={"/case_studies"} className="fs-17 tc-primary">
                        Case Studies
                      </Link>
                    </li> */}
                    <li className="pb-1">
                      <Link to={"/blogs"} className="fs-17 tc-primary">
                        Blogs
                      </Link>
                    </li>
                    <li className="pb-1">
                      <Link to={"/carrers"} className="fs-17 tc-primary">
                        Careers
                      </Link>
                    </li>
                    {/* <li className="pb-1">
                      <Link to={"/privacy-policy"} className="fs-17 tc-primary">
                        Privacy Policy
                      </Link>
                    </li>
                    <li className="pb-1">
                      <Link
                        to={"/term-and-conditions"}
                        className="fs-17 tc-primary"
                      >
                        Terms & Conditions
                      </Link>
                    </li>
                    <li className="pb-1">
                      <Link
                        to={"/cancellation-policy"}
                        className="fs-17 tc-primary"
                      >
                        Cancellation & Refund Policy
                      </Link>
                    </li> */}
                    <li className="pb-1">
                      <Link to={"/contact"} className="fs-17 tc-primary">
                        Contact Us
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="col-md-7">
                  <div className="d-flex align-items-center flex-wrap social-links py-4 py-md-0 pb-4">
                    <a
                      href="https://www.instagram.com/pluralcode/?igshid=YmMyMTA2M2Y%3D"
                      target="_blank"
                      className="tc-primary fs-17"
                    >
                      <i className="fa-brands fa-instagram" />
                    </a>
                    <a
                      href="https://www.facebook.com/pluralcode"
                      target="_blank"
                      className="tc-primary fs-17"
                    >
                      <i className="fa-brands fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/plural-code-technologies"
                      target="_blank"
                      className="tc-primary fs-17"
                    >
                      <i className="fa-brands fa-linkedin" />
                    </a>
                  </div>
                  <p className="fs-17 head-font py-md-3 py-2 tc-primary">
                    <strong>Plural Code Technologies</strong>
                    <br />
                    {/* <span className="fs-14">
                      (part of <b>Sarentu IT Solutions Pvt. Ltd.</b>)
                    </span> */}
                    {/* <br /> */}
                    <br />
                    A1/129
                    <br />
                    Sector - 17, Rohini,
                    <br />
                     New Delhi, 110089, India
                    <br />
                    <br />
                    Phone:{" "}
                    <a className="tc-primary fs-17" href="tel:+919958920231">
                      +919958920231
                    </a>
                    <br />
                    Email:{" "}
                    <a
                      className="tc-primary fs-17"
                      href="mailto:info@pluralcode.com"
                    >
                      info@pluralcode.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h5 className="tc-primary fs-17" style={{ textAlign: "center" }}>
        Copyright 2016 - {new Date().getFullYear()} Plural Code Technologies{" "}
        {/* <span className="fs-14">
          (part of <b>Sarentu IT Solutions Pvt. Ltd.</b>)
        </span> */}
        . All rights reserved.
      </h5>
    </footer>
  );
}
